import React, { useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useAuth } from "../../context/AuthContext"; // Importiere den AuthContext

const PayPalSubscription = ({ userId }) => {
    const { updateUserRole } = useAuth();
    const [subscriptionId, setSubscriptionId] = useState(null);
    const [error, setError] = useState(null);

    const getAuthToken = () => {
        return localStorage.getItem("token") || sessionStorage.getItem("token");
    };

    const handleApprove = async (data) => {
        try {
            const token = getAuthToken();

            if (!token) {
                setError("Benutzer nicht authentifiziert.");
                return;
            }

            const response = await fetch("/api/subscriptions/verify", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ subscriptionId: data.subscriptionID, userId }),
            });

            const result = await response.json();
            if (result.success) {
                setSubscriptionId(data.subscriptionID);

                const newRoleId = result.newRoleId || 2; // Standardwert setzen, falls `newRoleId` nicht kommt
                updateUserRole(newRoleId); // Aktualisiert die `role_id` im AuthContext und localStorage
            } else {
                setError("Fehler bei der Abo-Aktivierung.");
            }
        } catch (err) {
            setError("Ein Problem ist aufgetreten.");
        }
    };

    return (
        <PayPalScriptProvider options={{ "client-id": "AUlujujZTgtpl3N3BJh6Pp7q_tGoagRcJPQ9BktTMiOEo94CwEliwSvbfZW0KCOXBM8KD7CU5muDlFbG", vault: true }}>
            <div className="p-4 bg-white rounded-lg shadow-md">
                <h2 className="text-lg font-bold mb-2">Monatsabo abschließen</h2>
                {subscriptionId ? (
                    <p className="text-green-600 font-semibold">
                        Abo aktiv! Deine ID: {subscriptionId}
                    </p>
                ) : (
                    <PayPalButtons
                        style={{
                            layout: "vertical",
                            color: "black",
                            shape: "rect",
                            label: "subscribe",
                        }}
                        createSubscription={(data, actions) => {
                            return actions.subscription.create({
                                plan_id: "P-0TP36924VF676351FNCOFSEY",
                            });
                        }}
                        onApprove={(data) => handleApprove(data)}
                        onError={() => setError("Zahlung fehlgeschlagen.")}
                    />
                )}
                {error && <p className="text-red-600 mt-2">{error}</p>}
            </div>
        </PayPalScriptProvider>
    );
};

export default PayPalSubscription;